"use strict"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider.state("mainmap.home", {
    url: "/home",
    views: {
      "extrapanel@mainmap": "homepanel",
    },
    resolve: {
      campsiteinfo: function (campsitedata) {
        return campsitedata
      },
    },
  })
}
